import request from '../../utils/request';

export const search = (param) => {
    return request({
        url: '/line/search',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: param
    })
}

export const downloadFile = (param) => {
    return request({
        url: '/line/export',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        fullResponse: true,
        responseType: 'blob',
        data: param
    })
}


